import currency from "currency.js";
import { Table } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";
import { FilesAttachments } from "../../utils/Attachments";

// Extracted ItemTable component
export function ItemTable({
  tableData,
  selectedData,
  onSelected,
  selectAll,
  updateTableItem,
  disableInput,
  vendorAttachments,
  backendUrl,
  isSelected,
}) {
  return (
    <div className="mx-3">
      <Table responsive borderless striped className="product-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={selectAll}
                checked={
                  selectedData.length > 0 &&
                  selectedData.length === tableData.length
                }
                disabled={isSelected}
              />
            </th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>Unit Cost</th>
            <th>Quantity</th>
            <th>Subtotal</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  onChange={() => onSelected(row)}
                  checked={selectedData.some((item) => item.id === row.id)}
                  disabled={isSelected}
                />
              </td>
              <td className="p-cursor">{row.barcode}</td>
              <td>{row.itemName}</td>
              <td>
                <CurrencyInput
                  className="form-control border-1 px-1"
                  value={row.amount}
                  disabled={disableInput}
                  onKeyDown={(e) => e.keyCode === 13 && e.target.blur()}
                  name="amount"
                  onValueChange={(value) =>
                    updateTableItem({
                      index,
                      name: "amount",
                      value,
                    })
                  }
                  decimalsLimit={2}
                />
              </td>
              <td>{row.quantity}</td>
              <td>
                <CurrencyInput
                  className="form-control border-0 px-0"
                  name="subtotal"
                  disabled
                  value={
                    !isNaN(row.amount * row.quantity)
                      ? currency(row.amount, {
                          precision: 2,
                        }).multiply(row.quantity)
                      : 0
                  }
                  onKeyDown={(e) => e.keyCode === 13 && e.target.blur()}
                  onValueChange={() =>
                    updateTableItem({
                      index,
                      name: "subtotal",
                      value: row.subtotal,
                    })
                  }
                  decimalsLimit={2}
                />
              </td>
              <td>{row?.remark}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {vendorAttachments.length > 0 && (
        <div className="my-4 col-md-6">
          <p className="mb-2">Attachments:</p>
          <FilesAttachments
            files={vendorAttachments.map((attachment) =>
              !attachment?.fileId
                ? attachment
                : {
                    ...attachment,
                    systemFileName: `${attachment.systemFileName}/${
                      attachment.name
                    }`,
                  },
            )}
            colWidth="3"
            url={`${backendUrl}/api/vendors/files`}
            viewOnly
          />
        </div>
      )}

      {tableData.length > 0 && (
        <div className="d-flex justify-content-end mb-3">
          <div className="gridChild gridChildBorderLeftBlue">
            <div className="gridChildLeft">
              <p className="gridChld1">
                {currency(
                  tableData.reduce(
                    (sum, item) => sum + item.amount * item.quantity,
                    0,
                  ),
                  { symbol: "" },
                ).format()}
              </p>
              <p className="gridChld2">Total</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
